<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="Part 1: Nonfiction">
<p class="Part-number" id="part01"><a href="#/text/Contents#apart01">PART 1</a></p>
<p class="Part-title"><span epub:type="pagebreak" id="page_5" title="5"><a href="#/text/Contents#apart01">NONFICTION</a><span epub:type="pagebreak" id="page_6" title="6"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?767371d8